import { useContext } from "react"
import { AppContext } from "./context"

const UiButton3 = ({ text, left, w, logo, submit }) => {


	const { dataFetchLoading } = useContext(AppContext)


	return (
		<div className={text ? "button3	" : null} onClick={submit} style={{ cursor: "pointer" }}>
			<div className="d-flex ustify-content-center" style={{ width: w ? w : "100%" }}>

				{left &&

					<div className=" align-self-center flex-grow-1 text-center ps-3 pe-2" onClick={submit}>
						<span className="w-100">{text}</span>
					</div>
			

				}

				<div
					onClick={dataFetchLoading ? null : submit}
					className="d-flex gap-2 justify-content-center" style={{ width: 42, height: 42, borderRadius: 25, border: "1px solid lightgray", cursor: "pointer" }}>
					<img className="align-self-center" src={logo || ("/src/back-arrow.png")} style={{ width: 15, height: 15, transform: (left ? "scaleX(-1)" : "none") }} />
				</div>

				{left == false && <div className="ps-2 pe-3 align-self-center"><p className="w-100 mb-0 ">{text}</p></div> }

			</div>
		</div>
	)
}

export default UiButton3